<div class="flex items-center gap-7 font-sans w-full justify-end relative right-8 bottom-2 xl:bottom-0">
  <div 
  *ngIf="hasData"
  class="flex items-center gap-1.5">
    <span class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] bg-dimot-2 rounded-sm"></span>
    <h2 class="text-[0.5em] xl:text-[0.6em] text-gray-500">Forecast</h2>
  </div>
  <div 
  *ngIf="hasData"
  class="flex items-center gap-1.5">
    <span class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] rounded-sm bg-dimot-1"></span>
    <h2 class="text-[0.5em] xl:text-[0.6em] text-gray-500">Actual</h2>
  </div>
</div>

<div class="relative">
  <!-- Container graph with overlay -->
  <div class="relative w-full h-full right-[13px] xl:right-0"
  >
    <canvas [id]="chartId" class="dimot-chart-main"></canvas>
    
    <!-- Overlay for no data -->
    <div *ngIf="!hasData" class="absolute inset-0 flex items-center justify-center z-10">
      <div class="text-center ">
        <p class="text-gray-800">Non ci sono dati da mostrare</p> 
      </div>
    </div>
  </div>
</div>

<app-modal-open-to-access-curve
  *ngIf="isAccessCurveOpen"
  [curvePointData]="curvePointData"
  (isModalOpen)="onOpenAccessCurveModal($event)"
>
</app-modal-open-to-access-curve>
